$(document).ready(function () {
  // Prepend General Message Banner to Header
  $('.generalmessage').prependTo('header');
  fixFeatureButton();
});

$(window).load(function () {
  contentMarginTop();
});

$(window).on('resize', function () {
  contentMarginTop();
});

// Calculate content margin top
function contentMarginTop() {
  function updateContentMargin() {
    const headerHeight = $('header').outerHeight();
    const generalMessageHeight = $('.generalmessage').outerHeight();
    const windowWidth = window.innerWidth;
    const extraMargin = windowWidth <= 1000 ? 35 : 85;

    if ($('body').hasClass('saffireWindowScrolled')) {
      $('header').css('top', -generalMessageHeight + 'px');

      if ($('body').hasClass('homepage')) {
        $('.content').css('margin-top', headerHeight - generalMessageHeight + 'px');
      } else {
        $('.content').css('margin-top', headerHeight - generalMessageHeight + extraMargin + 'px');
      }
    } else {
      $('header').css('top', '0');

      if ($('body').hasClass('homepage')) {
        $('.content').css('margin-top', headerHeight + 'px');
      } else {
        $('.content').css('margin-top', headerHeight + extraMargin + 'px');
      }
    }
  }

  const interval = setInterval(function () {
    if ($('body').hasClass('pageIsLoaded')) {
      updateContentMargin();
      clearInterval(interval);
    }
  }, 300);

  $(window).on('scroll', function () {
    updateContentMargin();
  });
}

// Style Feature Button
function fixFeatureButton() {
  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);

    lineupButtonsGrid($element);
  });
}

function lineupButtonsGrid(lineup) {
  const containerSize = lineup.width();
  const buttonContainer = lineup.find('.featureLineup-buttons.subContainer');
  const icons = buttonContainer.find('.featureLineup-social');
  const buttons = buttonContainer.find('.featureLineup-buynow');

  // if icons length + buttons length is greater than containerSize then add class "column" to buttonContainer
  if (icons.width() + buttons.width() > containerSize - 20) {
    buttonContainer.addClass('column');
  }

  // remove icons if there 0 children

  if (!icons.children().length) {
    icons.remove();
  }
}
